/**
 * Handles stale chunk/module hash errors after a deploy by forcing
 * one hard refresh, then preventing infinite refresh loops.
 */
export function lazyImportWithRefresh(importer, key) {
  return async () => {
    try {
      const module = await importer();
      // Import succeeded; clear retry marker so future deploys can recover.
      sessionStorage.removeItem(`lazy-refresh:${key}`);
      return module;
    } catch (error) {
      const marker = `lazy-refresh:${key}`;
      const alreadyRefreshed = sessionStorage.getItem(marker) === '1';
      const message = String(error?.message || '');
      const isChunkOrModuleError =
        message.includes('Failed to fetch dynamically imported module') ||
        message.includes('Importing a module script failed') ||
        message.includes('dynamically imported module');

      if (!alreadyRefreshed && isChunkOrModuleError) {
        sessionStorage.setItem(marker, '1');
        window.location.reload();
        return new Promise(() => {});
      }

      throw error;
    }
  };
}
